import React from 'react';
import PropTypes from 'prop-types';
import { TextInput, Label } from '@gsa/afp-component-library';

const CommentSection = ({
  commentBody,
  onCommentChange,
  required = false,
  errorMessage = '',
}) => (
  <>
    <Label className="text-bold" required={required}>
      Comments
    </Label>
    <TextInput
      type="textarea"
      data-testid="make-model-comment-section"
      className=" height-card width-full comment"
      aria-label="comment"
      value={commentBody}
      onChange={(e) => onCommentChange(e.target.value)}
      characterLimit={1000}
      errorMessage={errorMessage}
      required
    />
  </>
);

CommentSection.propTypes = {
  commentBody: PropTypes.string.isRequired,
  onCommentChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  errorMessage: PropTypes.string,
};

export default CommentSection;
